module.exports ={
  "propertyService": "https://iwjpkyu355.execute-api.us-east-1.amazonaws.com/prd",
  "domusoApiService": "https://nlwrxt6aj8.execute-api.us-east-1.amazonaws.com/prd",
  "appService": "https://domusograilsweb-prd.domuso.com",
  "reservationService": "https://9xbvhk2lvl.execute-api.us-east-1.amazonaws.com/prd",
  "userPoolId": "us-east-1_2vMAPQtht",
  "authService": "https://d3pfgllpgh.execute-api.us-east-1.amazonaws.com/prd",
  "userPoolWebClientId": "1k1mgbsu3hbu5eqfosmng9rga0",
  "emailLinkBase": "https://app.domuso.com",
  "payWithUrl": "https://paywith.domuso.com",
  "supportEmail": "support@domuso.com",
  "datadogEnabled": "true",
  "datadog": {
    "applicationId": "a8a3ef3e-6f85-4910-b1ce-f3ece82b8107",
    "clientToken": "pub625b9a53faa6769970607a99dfcb00e7"
  },
  "residentWebUI": "https://residentweb.domuso.com"
}